var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[_c('app-bar',_vm._b({},'app-bar',_vm.bar,false)),_c('drawer',_vm._b({nativeOn:{"mouseleave":function($event){return _vm.setMini(true)}}},'drawer',_vm.drawer,false)),_c('app-view',_vm._b({},'app-view',_vm.view,false)),_c('view-footer',_vm._b({},'view-footer',_vm.footer,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }